import React from 'react';
import { useState } from 'react';


// html remover remains the same
const stripPTags = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]+>/g, "");
};

const OverviewContent = ({ vendor, isExpanded, setIsExpanded }) => {
    
    // --- Dynamic Limit Logic ---
    const MOBILE_WORD_LIMIT = 15;
    const DESKTOP_WORD_LIMIT = 70;
    const isMobileBreakpoint = typeof window !== 'undefined' && window.innerWidth < 768;

    const currentLimit = isMobileBreakpoint ? MOBILE_WORD_LIMIT : DESKTOP_WORD_LIMIT;
    const rawDescription = vendor?.profile?.businessProfile || "";
    const descriptionText = stripPTags(rawDescription) || "No description available.";
    
    const words = descriptionText.split(/\s+/).filter(word => word.length > 0);
    const descriptionWordCount = words.length;
    const needsReadMore = descriptionWordCount > currentLimit;

    const truncatedWords = words.slice(0, currentLimit);
     const [showAllAmenities, setShowAllAmenities] = useState(false);
     const amenities = vendor?.amenities || [];
     const visibleAmenities = showAllAmenities ? amenities : amenities.slice(0, 2);


    return (
        <div className=" my-[-16px] sm:my-[-10px]  sm:mt-[-4px]"> 
            {/* DESCRIPTION SECTION */}
            <div className="border border-[#FD590133] p-2 sm:p-3 lg:p-4 my-4sm:my-6">
                <p className="text-[#000048] text-sm sm:text-base lg:text-base leading-relaxed">
                    
                    {/* 1. If expanded OR if word count is less than the limit, show full text */}
                    {isExpanded || !needsReadMore ? (
                        descriptionText
                    ) : (
                        // 2. Otherwise, show truncated text with Read More button
                        <>
                        {truncatedWords.join(" ")}
                        ...
                        <button 
                            onClick={() => setIsExpanded(true)} 
                            className="text-[#FD5901] font-medium text-sm sm:text-base lg:text-lg ml-1 hover:underline"
                        >
                            Read more
                        </button>
                        </>
                    )}
                </p>

                {/* Show Read less button only if expanded AND truncation was originally needed */}
                {isExpanded && needsReadMore && (
                    <button 
                        onClick={() => setIsExpanded(false)} 
                        className="text-[#FD5901] font-medium text-sm sm:text-base lg:text-lg mt-2 hover:underline"
                    >
                        Read less
                    </button>
                )}
             {/* 🔸 DIVIDER */}
                {amenities.length > 0 && (
                    <div className="border-t border-gray-100 my-2"></div>
                )}
                {/* 🔶 AMENITIES */}
                {amenities.length > 0 && (
                    <div>           
                        <h3 className="text-[#000048] text-sm sm:text-base font-semibold mb-2 flex items-center gap-2">
                            <span>🐾</span>
                            Amenities & Facilities
                        </h3>
                        {/* GRID */}
                       <div className="flex flex-wrap gap-2">
                        {visibleAmenities.map((item, index) => (
                            <div
                            key={index}
                            className="flex items-center gap-1.5 px-2 py-1.5 rounded-md bg-gray-50 hover:bg-gray-100 transition"
                            >
                            <svg
                                className="w-3.5 h-3.5 text-green-500 flex-shrink-0"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                            <span className="text-xs sm:text-sm text-[#000048] whitespace-nowrap">
                                {item}
                            </span>
                            </div>
                        ))}
                        </div>

                        {/* 🔽 SHOW MORE / LESS BUTTON */}
                        {amenities.length > 4 && (
                            <button
                                onClick={() => setShowAllAmenities(!showAllAmenities)}
                                className="mt-3 text-[#FD5901] text-sm font-medium hover:underline"
                            >
                                {showAllAmenities 
                                    ? "Show less" 
                                    : `Show all ${amenities.length} amenities`
                                }
                            </button>
                        )}
                    </div>
                )}

            </div>
        </div>
    );
};

export default OverviewContent;